module.exports = __webpack_public_path__ + "static/img/viagem.74ea998.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/viagem.jpg
// module id = KRoE
// module chunks = 1